import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import {
  ElementDetailsAction,
  ElementDetailsActionParam,
} from "models/Resources/ElementDetailsResource";
import * as React from "react";

type ActionParamsProps = {
  elementAction: ElementDetailsAction;
  onActionConfirm: (isConfirmed: boolean, values?: any) => void;
};

export default function FormDialog({
  elementAction,
  onActionConfirm,
}: ActionParamsProps) {
  const [open, setOpen] = React.useState(true);

  const handleCancel = () => {
    onActionConfirm(false);
    handleClose();
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const formData = new FormData(event.currentTarget);
    const formJson = Object.fromEntries((formData as any));
    const params: ElementDetailsActionParam[] = [];
    for(const [key, value] of Object.entries(formJson)) {
      const p: ElementDetailsActionParam = {
        id: key,
        valeur: value
      };
      params.push(p);
    }
    onActionConfirm(true, params);
    handleClose();
  };

  function getParams() {
    const params: React.JSX.Element[] = [];
    elementAction.parametres?.map((param) => params.push(createParam(param)));
    return params;
  }

  function createParam(param: ElementDetailsActionParam): React.JSX.Element {
    if (param.typeUI?.toLocaleUpperCase() === 'MULTILINES') {
    return (
      <>
        <TextField
          id={"param" + param.id}
          name={param.id}
          label={param.etiquette}
          multiline
          rows={4}
          helperText={param.aide}
        />
      </>
    );

    } 
    return <>
    <div>
            <TextField
          id={"param" + param.id}
          name={param.id}
          fullWidth
          label={param.etiquette}
          helperText={param.aide}
        />
    </div>
    </>;
  }
  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleCancel}
        className="dialog-window"
        maxWidth={false}
        slotProps={{
          paper: {
            sx: {
              minWidth: "600px",
              minHeight: "250px",
            },
          },
        }}
      >
      <DialogTitle id="confirm-action-title">
        {"Paramètres"}
        <IconButton
          id="dialog-close-btn"
          aria-label="close"
          onClick={handleCancel}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

        <DialogContent dividers
        className="dialog-body"
        style={{
          padding: "45px",
          borderStyle: "hidden",
        }}>
          <form onSubmit={handleSubmit} id="subscription-form" style={ { width: "100%" }}>
             <Box sx={{ display: "grid", gap: 2 }}>
            {getParams()}
            </Box>
          </form>
        </DialogContent>
        <DialogActions style={{ justifyContent: "center" }}>
          <Button
            autoFocus
            className="dialog-buttons"
            style={{
              backgroundColor: "white",
              color: "black",
              width: "35%",
            }}
            variant="outlined"
            onClick={() => handleCancel()}
          >
            {"Annuler"}
          </Button>
          <Button
            autoFocus
            type="submit"
            form="subscription-form"
            className="dialog-buttons"
            style={{
              backgroundColor: "#1976d2",
              color: "white",
              width: "35%",
            }}
            variant="contained"
          >
            {"Confirmer"}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
